import { connect } from 'react-redux';
import LoyaltyDownloadAppPopup  from './loyalty_download_app_popup';
import withPGTranslation from '../../../../../config/withPGTranslation';

const mapStateToProps = ({ application: { dynamicConfig } }: any) => ({
  url: dynamicConfig?.url
});

export default connect(
  mapStateToProps,
  {}
)(withPGTranslation(LoyaltyDownloadAppPopup));
